import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as profitLossService from '../services/profitLossService'
import * as userService from '../services/userService'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import Toast from './sub_components/toast';
import { casinoList } from '../configs/casinoShowList';

class CasinoReport extends Component {
   constructor(props) {
      super(props);
      this.state = {
         pnl_datanew:{},
         totalpnl: 0, 
         totalcommission: 0,
         totalnew: 0,
         from: "",
         to: "",
         accounts: "",
         client_id: "",
         usersList: [],
         toastMsg: "",
         toastType: "",
         showToast: false,
         showData: false,
         loader: false,
         showPopup : false,
         isPnlData: false,
         eventNameById: {"1": "Soccer", "2": "Tennis", "4": "Cricket", "400": "Kabaddi", "500": "Election", "7": "Horse Racing", "4339": "Greyhound Racing"}
      };
   }
   componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ accounts: userData.sub, to: curDate, from: weekDate })
   }
   parseToPickerDate(date) {
      let dtArr = date.split("/")
      let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
      return dt
   }
   parseFilterBody() {
      // let body = { 
      //    "user_id": this.state.accounts,
      //    "client_id": this.state.client_id,
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      // }
      let body = {
         "userId": this.state.client_id,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({ loader: true, totalnew: 0 })
      await profitLossService.postProfitLoss(body).then((res) => {
         let pnl_newdata={
            "MATCH_ODDS_4":{et:"4", sport:"Cricket", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_4":{et:"4", sport:"Cricket", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "TIED_MATCH_4":{et:"4", sport:"Cricket", mt:"TIED_MATCH", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "COMPLETED_MATCH_4":{et:"4", sport:"Cricket", mt:"COMPLETED_MATCH", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_4":{et:"4", sport:"Cricket", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "FANCY_4":{et:"4", sport:"Cricket", mt:"FANCY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "LINE_4":{et:"4", sport:"Cricket", mt:"LINE", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "MATCH_ODDS_1":{et:"1", sport:"Soccer", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_1":{et:"1", sport:"Soccer", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_35_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_35", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_25_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_25", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_15_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_15", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_05_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_05", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_1":{et:"1", sport:"Soccer", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "MATCH_ODDS_2":{et:"2", sport:"Tennis", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_2":{et:"2", sport:"Tennis", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_2":{et:"2", sport:"Tennis", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "WIN_7":{et:"7", sport:"Horse Racing", mt:"WIN", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "WIN_4339":{et:"4339", sport:"Greyhound Racing", mt:"WIN", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_400":{et:"400", sport:"Kabaddi", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_500":{et:"500", sport:"Election", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "FANCY_500":{et:"500", sport:"Election", mt:"FANCY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "DAILY_300":{et:"300", sport:"Binary", mt:"DAILY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "1_HOUR_300":{et:"300", sport:"Binary", mt:"1_HOUR", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "2_HOUR_300":{et:"300", sport:"Binary", mt:"2_HOUR", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0}
         }
         //    "INDIAN_POKER_99":{et:"99", sport:"Casino", mt:"INDIAN_POKER", bt:"LOTUS", pnl_commission: 0},
         //    "INDIAN_POKER_2_99":{et:"99", sport:"Casino", mt:"INDIAN_POKER_2", bt:"SUPERNOVA", pnl_commission: 0},
         //    "CASINO_99":{et:"99", sport:"Casino", mt:"CASINO", bt:"DRC || QTECH", pnl_commission: 0},
         //    "EVOLUTION_99":{et:"99", sport:"Casino", mt:"EVOLUTION", bt:"ODDS", pnl_commission: 0},
         //    "DIGITAIN_999":{et:"999", sport:"SportBook", mt:"SPORTBOOK", bt:"ODDS", pnl_commission: 0}
         // }

         for(const itm of casinoList){
            if(itm.show){
               pnl_newdata[itm.pnlLabel] = {et:"99", sport:"Casino", mt:itm.mt, bt:itm.bt, pnl: 0, commission: 0, pnl_commission: 0};
            }
         }

         pnl_newdata["DIGITAIN_999"] = {et:"999", sport:"SportBook", mt:"SPORTBOOK", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0};

         if (res.isSuccess) {
            self.setState(
               {
                  pnl_datanew:{},
                  totalnew:0,
                  isPnlData: false,

               }, () => {
                  
                  let totalpnl = 0
                  let totalcommission = 0
                  let totalnew = 0
                  res.items.length > 0 && Array.prototype.forEach.call(res.items,(it) => {

                     if ((it._id.bt === "ODDS" || it._id.bt === "BOOKMAKER") && it._id.et !== "99" && it._id.et !== "999") {
                        pnl_newdata[`${it._id.mt}_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`${it._id.mt}_${it._id.et}`].commission += it.commission 
                        pnl_newdata[`${it._id.mt}_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.bt === "LINE" && it._id.provider !== "BETFAIR" && it._id.et === "4") {
                        pnl_newdata[`FANCY_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`FANCY_${it._id.et}`].commission += it.commission
                        pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.bt === "LINE" && it._id.provider === "BETFAIR" && it._id.et === "4") {
                        pnl_newdata[`LINE_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`LINE_${it._id.et}`].commission += it.commission
                        pnl_newdata[`LINE_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.bt === "LINE" && it._id.et === "500") {
                        pnl_newdata[`FANCY_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`FANCY_${it._id.et}`].commission += it.commission
                        pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.mt === "DAILY" && it._id.et === "300") {
                        pnl_newdata[`DAILY_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`DAILY_${it._id.et}`].commission += it.commission
                        pnl_newdata[`DAILY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.mt === "1_HOUR" && it._id.et === "300") {
                        pnl_newdata[`1_HOUR_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`1_HOUR_${it._id.et}`].commission += it.commission
                        pnl_newdata[`1_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     else if (it._id.mt === "2_HOUR" && it._id.et === "300") {
                        pnl_newdata[`2_HOUR_${it._id.et}`].pnl += it.pnl
                        pnl_newdata[`2_HOUR_${it._id.et}`].commission += it.commission
                        pnl_newdata[`2_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     } else if(it._id.et === "99"){
                        //let obj = pnl_newdata[`${it._id.provider}_${it._id.et}`];
                        const objkey = `${(it._id.provider === "LOTUS" ? "INDIAN_POKER" : (it._id.provider === "SUPERNOVA" ? "INDIAN_POKER_2" : (it._id.provider === "DRC" || it._id.provider === "QTECH" ? "CASINO" :(it._id.provider === "DRCROYAL"? "ROYAL_CASINO" :it._id.provider))))}_${it._id.et}`
                        if(!!pnl_newdata[objkey]){
                           pnl_newdata[objkey].pnl += it.pnl
                           pnl_newdata[objkey].commission += it.commission
                           pnl_newdata[objkey].pnl_commission += it.pnl + it.commission;
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission;
                        }
                     }
                     else if (it._id.provider === "DIGITAIN") {
                        pnl_newdata[`DIGITAIN_999`].pnl += it.pnl
                        pnl_newdata[`DIGITAIN_999`].commission += it.commission
                        pnl_newdata[`DIGITAIN_999`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     // else if (it._id.provider === "LOTUS") {
                     //    pnl_newdata[`INDIAN_POKER_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "SUPERNOVA") {
                     //    pnl_newdata[`INDIAN_POKER_2_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "DRC" || it._id.provider === "QTECH") {
                     //    pnl_newdata[`CASINO_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "EVOLUTION") {
                     //    pnl_newdata[`EVOLUTION_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                  })

                  
                  this.setState({ pnl_datanew: pnl_newdata, totalnew: totalnew, totalpnl: totalpnl, totalcommission: totalcommission, isPnlData: res.items.length > 0 ? true : false, showData: true, loader: false })
               }
            );
         } else {
            this.props.notify(res.message, "error")
            this.setState({ pnl_datanew:{}, totalnew:0, isPnlData: false, showData: true, loader: false })
         }
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate, showData:false})
   }
   onShowPopup(){
      this.setState({ showPopup : true})
   }
   onHidePopup(){
      this.setState({ showPopup : false})
   }
   onSubmit(e) {
     
         this.setState({showData:true });
      
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d, isPnlData: false, showData: false, pnl_datanew: {}, totalnew:0 })
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.accounts, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   render() {

      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Casino Report</h5>
                           <div className="row mx-0">
                              
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.from}
                                       onChange={(e) => this.onDateTimeChange("from", e)}
                                       id="from_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.to}
                                       onChange={(e) => this.onDateTimeChange("to", e)}
                                       id="to_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    {/* <label className="mb-0 pb-1 mt-1">Select Sport</label> */}
                                    <select title="Event Type" className="form-control" name="eventType" >
                                       <option value="LOTUS">Indian Poker</option>
                                       <option value="CASINO">Casino</option>
                                       <option value="EVOLUTION">Evolution</option>
                                       <option value="VIVO">Vivo</option>
                                       {/* {this.state.operators_list.length > 0 ? this.state.operators_list.map((operator, i) => <option key={i} value={operator}>{operator}</option>) : ""} */}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>
                           </div>
                           {/* {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null} */}
                           {!!this.state.showData && <div>
                              <div className="table-responsive">
                                 <table id="example" className="table table-striped table-bordered table-sm addpadding">
                                    <thead>
                                       <tr>
                                          <th className="wid165 pthead">Datetime</th>
                                          <th className="pthead">Game Name</th>
                                          <th className="pthead text-right">P &amp; L</th>
                                       </tr>
                                    </thead>
                                    <tbody id="tblAccountStatement">
                                      
                                          <tr>
                                             <td>{new Date().toLocaleString("hi-IN")}</td>
                                             <td><a className="undline" onClick={(e) => this.onShowPopup()}>Teen Patti</a></td>
                                             <td className='text-right text-success fbold'>15000.00</td>
                                          </tr>
                                          <tr>
                                             <td>{new Date().toLocaleString("hi-IN")}</td>
                                             <td><a className="undline" onClick={(e) => this.onShowPopup()}>Roulette</a></td>
                                             <td className='text-right text-danger fbold'>-1000.00</td>
                                          </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>}
                           {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
            {this.state.showPopup && 
               <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog  modal-dialog-scrollable">
                  <div className="modal-content">

                     <div className="modal-header">
                        <h4 className="modal-title">Results</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.onHidePopup() }}>×</button>
                     </div>
                     <div className="modal-body pt-0">
                     <div className="row">
                        <div className="col-12">
                           <div className="table-responsive" style={{ padding: 20, paddingTop:0 }}>
                              <table id="example" className="table table-bordered font-14 tab-ttoptip whitespace">
                                 <thead>
                                    <tr>
                                       <td>User Name</td>
                                       <td>Distributor</td>
                                       <td className="text-right">P &amp; L</td>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr className="umbbgcolor font-weight-bold">
                                       <td>john</td>
                                       <td>jimi</td>
                                       <td className='text-right text-success fbold'>30000</td>
                                    </tr>
                                    <tr className="umbbgcolor font-weight-bold">
                                       <td>mike</td>
                                       <td>karl</td>
                                       <td className='text-right text-success fbold'>50000</td>
                                    </tr>
                                    <tr className="umbbgcolor font-weight-bold">
                                       <td>alex</td>
                                       <td>jimi</td>
                                       <td className='text-right text-danger fbold'>-5000</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                     </div>
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.onHidePopup() }}></div>
            </div>     
            }
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoReport);